import React from "react";
import { useTranslation } from "react-i18next";

import { CellProps } from "../../../../../components/dataGrid/dataGrid";
import { TenantListViewModel } from "../../TenantList/tenantList.model";

import CopyInvitationLink from "./copyInvitationLink";

import "./tenantLinkCell.scss";

const TenantLinkCell: React.FC<CellProps<TenantListViewModel>> = ({ data: { value, data } }) => {
    const { t } = useTranslation();
    const { isConnected } = data;

    if (!isConnected) {
        return <CopyInvitationLink instanceId={data.ID} />
    }

    return <a className="cell--link" href={value} target="_blank" rel="noopener noreferrer">{t('partnerPortal.openInSyskitPoint')}</a>
}

export default React.memo(TenantLinkCell);